import { useContext } from 'react';
import { ViewportContext } from './ViewportContext.js';

/**
 * Returns the current viewport information.
 *
 * @returns The current viewport information.
 * @category Hooks
 * @example
 * ```tsx
 * import { useViewport } from '@sbt-web/hooks';
 *
 * function Example() {
 *   const { isMobile, viewport } = useViewport();
 *   return <span>{isMobile ? 'Mobile layout' : `Viewport: ${viewport}`}</span>;
 * }
 * ```
 */
function useViewport() {
    const context = useContext(ViewportContext);
    if (!context) {
        throw new Error('useViewport must be used within a ViewportProvider. ' +
            'Please wrap your component tree with ViewportProvider.');
    }
    return context;
}

export { useViewport };
//# sourceMappingURL=useViewport.js.map
